import { HeaderAlertService } from '@uxdf/direct-shared-lib';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BannerTileHelperService {
  constructor(private readonly alert: HeaderAlertService) {}

  public alertError(message: string) {
    this.alert.clean();
    this.alert.add({ type: 'error', content: message });
  }
}
